import { render, staticRenderFns } from "./ProductView.vue?vue&type=template&id=f1daee58&"
import script from "./ProductView.vue?vue&type=script&lang=js&"
export * from "./ProductView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f1daee58')) {
      api.createRecord('f1daee58', component.options)
    } else {
      api.reload('f1daee58', component.options)
    }
    module.hot.accept("./ProductView.vue?vue&type=template&id=f1daee58&", function () {
      api.rerender('f1daee58', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/js/src/app/components/battery-store/ProductView.vue"
export default component.exports